<template>
  <div class="server-switch">
    <button
      v-if="showAll"
      type="button"
      class="server-pill"
      :class="{ active: activeServer === null }"
      @click="switchServer(null)"
    >
      All
    </button>
    <button
      type="button"
      class="server-pill silver"
      :class="{ active: activeServer === 'silver' }"
      @click="switchServer('silver')"
    >
      Silver
    </button>
    <button
      type="button"
      class="server-pill gold"
      :class="{ active: activeServer === 'gold' }"
      @click="switchServer('gold')"
    >
      Gold
    </button>
  </div>
</template>

<script>
  export default {
    name: 'MoneyToplist',
    props: {
      stats: {
        default: null
      },
      value: {
        default: null
      },
      showAll: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        activeServer: this.value
      }
    },
    methods: {
      switchServer (value) {
        this.activeServer = value
        this.$emit('input', value)
      }
    }
  }
</script>

<style scoped>
.server-switch {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #2a343b;
  padding: 3px;
  border-radius: 6px;
  border: 1px solid #324047;
}

.server-pill {
  border: none;
  background: transparent;
  color: #9eb1ba;
  font-size: 0.78rem;
  padding: 4px 10px;
  border-radius: 4px;
  transition: all 0.15s ease;
}

.server-pill.active {
  background: #324047;
  color: #e6f0f2;
  box-shadow: inset 0 0 0 1px rgba(42, 163, 169, 0.35);
}

.server-pill.silver.active {
  border: 1px solid rgba(42, 163, 169, 0.35);
}

.server-pill.gold.active {
  border: 1px solid rgba(42, 163, 169, 0.25);
}
</style>
